import React from 'react';
import CRMBoard from '../../components/admin-dashboard/crm/CRMBoard';

const ITProjectsCRM = () => {
  return <CRMBoard pipelineType="it-project" />;
};

export default ITProjectsCRM;
